import { createAction } from '@reduxjs/toolkit';

import { SagaPayload } from '../api.types';
import {
  CreateResourceRequest,
  DeleteResourceRequest,
  UpdateResourceRequest,
  ViewResourcesByTypeRequest
} from './resource.types';

export const requestCreateResource =
  createAction<SagaPayload<CreateResourceRequest>['payload']>('request/createResource');

export const requestUpdateResource =
  createAction<SagaPayload<UpdateResourceRequest>['payload']>('request/updateResource');

export const requestDeleteResource =
  createAction<SagaPayload<DeleteResourceRequest>['payload']>('request/deleteResource');

export const requestViewResourcesByType =
  createAction<SagaPayload<ViewResourcesByTypeRequest>['payload']>('request/viewResourcesByType');
